import React from "react";
import trans from "../../translations.json";

export const AnomalyNote = (props) => (
  <div>
    <p>
      <span className="cviz-circle" />
      {trans.anomalies.explanation[props.lang]}{" "}
      <a href="#spikes">{trans.anomalies.link[props.lang]} </a>
    </p>
  </div>
);

export const AnomalyNoteTable = (props) => (
  <div className="cviz-anomalyNote-table">
    <p>
      {props.date}
      <span className="cviz-anomalyExplain-table">
        <span className="cviz-circle-table" />
        {trans.anomalies.tableExplanation[props.lang]}{" "}
        <a href="#spikes">{trans.anomalies.tableLink[props.lang]}</a>
      </span>
    </p>
  </div>
);

export function getTableLabel(date, anomaliesList, lang) {
  let input;
  let tempDates = anomaliesList.map(function (item, index) {
    let newDate = new Date(anomaliesList[index]);
    return (item = newDate.toString());
  });
  let formattedDate = new Date(date + " 2020");
  if (tempDates.includes(formattedDate.toString())) {
    input = <AnomalyNoteTable date={date} lang={lang} />;
  } else {
    input = date;
  }
  return input;
}
